import { Box } from '@mui/material'

import { Banner } from '@/components/Banner/Banner'
import { Carousel } from '@/components/Carousel/Carousel'
import { useMedia } from '@/hooks/useMedia'

import type { FC } from 'react'
import type { SxProps } from '@mui/material'
import type { UnpackedSanityHeroBannerCarousel } from '@/lib/queries/sanityQueryStrings'

export const SanityHeroBanner: FC<{
  sanityComponent: UnpackedSanityHeroBannerCarousel
  sx?: SxProps
  heroBanner?: boolean
}> = ({ sanityComponent, sx }) => {
  const { isMobile } = useMedia()
  const contentBanners = sanityComponent?.contentBanners ?? []

  if (contentBanners.length === 0) {
    return null
  }

  return (
    <Box mt={isMobile ? 0 : 1} mb={3.5}>
      <Carousel
        sx={{ p: 0, ...sx }}
        heroBanner={true}
        settingsOverride={{
          autoplay: sanityComponent?.rotateAutomatically || false,
          autoplaySpeed: sanityComponent?.intervalTime || 5000,
        }}
        items={contentBanners.map((banner, idx) => <Banner key={`banner-${idx}`} data={banner} priority={idx === 0} />)}
      />
    </Box>
  )
}
